import { render, staticRenderFns } from "./ListCrmTrigger.vue?vue&type=template&id=515beadd&scoped=true"
import script from "./ListCrmTrigger.vue?vue&type=script&lang=js"
export * from "./ListCrmTrigger.vue?vue&type=script&lang=js"
import style0 from "./ListCrmTrigger.vue?vue&type=style&index=0&id=515beadd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515beadd",
  null
  
)

export default component.exports